import React, { useEffect, useState } from "react";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Users, X } from "lucide-react";

export function RelatedClients({ clientId, canEdit }) {
  const [rel, setRel] = useState([]);
  const [all, setAll] = useState([]);
  const [pick, setPick] = useState("");
  useEffect(() => { api.get(`/clients/${clientId}/related`).then((r) => setRel(r.data)); }, [clientId]);
  useEffect(() => { if (canEdit) api.get("/clients").then((r) => setAll(r.data)); }, [canEdit]);

  async function add() {
    try { const r = await api.post(`/clients/${clientId}/related`, { related_id: pick }); setRel(r.data); setPick(""); toast.success("Related client linked"); }
    catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  }
  async function remove(rid) { const r = await api.delete(`/clients/${clientId}/related/${rid}`); setRel(r.data); }
  const ids = new Set(rel.map((r) => r.id));

  return (
    <div className="border border-[var(--line)] rounded-sm p-3 mb-3" data-testid="related-clients-panel">
      <div className="label-overline mb-1 flex items-center gap-1"><Users size={11} /> Related clients · same owner</div>
      {rel.length === 0 && <div className="text-xs text-[var(--ink-2)]" data-testid="related-none">None linked.</div>}
      <div className="flex flex-wrap gap-1.5">
        {rel.map((r) => (
          <span key={r.id} data-testid={`related-${r.id}`} className="text-xs border border-[var(--line)] rounded-sm px-2 py-0.5 flex items-center gap-1">
            <span className="font-mono-data text-[10px] text-[var(--ink-2)]">{r.client_uid || ""}</span> {r.client_name}
            {canEdit && <button type="button" data-testid={`related-remove-${r.id}`} onClick={() => remove(r.id)}><X size={10} /></button>}
          </span>
        ))}
      </div>
      {canEdit && (
        <div className="flex gap-1.5 mt-2">
          <select data-testid="related-select" className="input-slim text-xs flex-1" value={pick} onChange={(e) => setPick(e.target.value)}>
            <option value="">— Link a related client —</option>
            {all.filter((c) => c.id !== clientId && !ids.has(c.id)).map((c) => <option key={c.id} value={c.id}>{c.client_uid ? `${c.client_uid} · ` : ""}{c.client_name}</option>)}
          </select>
          <button type="button" data-testid="related-add-btn" disabled={!pick} onClick={add} className="btn-ghost text-[11px] !py-1 !px-2">Link</button>
        </div>
      )}
    </div>
  );
}
